
const __default__ = {
  props: {
    src: {
      type: String,
      default: undefined  
    },
    loading: {
      type: Boolean,
      default: false
    },
    name: {
      type: String,
      default: undefined
    },
    size: {
      type: String,
      default: '10rem'
    },
    shape: {
      type: String,
      default: 'square'
    },
    placeholder: {
      type: String,
      default: undefined
    },
    initialsSize: {
      type: String,
      default: '90%'
    }
  },
  computed: {
    initials(){
      if(this.name){
        const name = this.name.split(' ')
        return name.length > 1 ? name[0][0] + name[1][0] :  name[0][0]
      }
      return undefined
    }
  }
}

import { useCssVars as _useCssVars } from 'vue'
const __injectCSSVars__ = () => {
_useCssVars(_ctx => ({
  "44d9304a-size": (_ctx.size),
  "44d9304a-initialsSize": (_ctx.initialsSize)
}))}
const __setup__ = __default__.setup
__default__.setup = __setup__
  ? (props, ctx) => { __injectCSSVars__();return __setup__(props, ctx) }
  : __injectCSSVars__

export default __default__